<template>
  <component :is="tagName" :class="classes" class="mdc-list" v-bind="$attrs" tabindex="0">
    <!-- @slot List content -->
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    /**
     * Styles the density of the list, making it appear more compact.
     */
    dense: {
      type: Boolean,
      default: false
    },
    /**
     * Modifier to style list with two lines (primary and secondary lines).
     */
    twoLine: {
      type: Boolean,
      default: false
    },
    /**
     * Disables interactivity affordances.
     */
    nonInteractive: {
      type: Boolean,
      default: false
    },
    /**
     * List tag html
     */
    tagName: {
      type: String,
      default: "ul"
    }
  },
  computed: {
    classes() {
      return {
        "mdc-list--dense": this.dense,
        "mdc-list--two-line": this.twoLine,
        "mdc-list--non-interactive": this.nonInteractive
      };
    }
  }
};
</script>
